export const gitlabUrl =
  process.env.VUE_APP_GITLAB_URL || "https://git.tu-berlin.de";
